<template>
	<div id="uploadbox">
		<!-- <div id="top">
			<span class="rightcha">
				<img width="20px" src="../../assets/cha.png" />
				<span class="centerwz">上传名单</span>
			</span>
		</div> -->
		<div id="mideen">
			<div style="line-height: 35px; font-weight: ">最高学历*</div>
			<div class="Select" @click="ShowPlacePopup">
			  <span style="float: left; color: rgb(186, 186, 186)"
			    >请选择学历</span
			  >
			  <span
			    style="float: right; margin-right: 10px; color: rgb(186, 186, 186)"
			    ><van-icon name="arrow-down"
			  /></span>
			</div>
			<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="PlaceShow"
			>
			  <!-- <h4>选择考试地点</h4> -->
			  <van-picker
			    show-toolbar
			    :columns="columns"
			    @confirm="onConfirm"
			    cancel-button-text="选择学历"
			  />
			</van-popup>
			<div style="line-height: 35px; font-weight: ">证书获取时间*</div>
			<div class="Select" @click="ShowPlacePopup">
			  <span style="float: left; color: rgb(186, 186, 186)"
			    >请选择时间</span
			  >
			  <span
			    style="float: right; margin-right: 10px; color: rgb(186, 186, 186)"
			    ><van-icon name="arrow-down"
			  /></span>
			</div>
			<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="PlaceShow"
			>
			  <!-- <h4>选择考试地点</h4> -->
			  <van-picker
			    show-toolbar
			    :columns="columns"
			    @confirm="onConfirm"
			    cancel-button-text="选择时间"
			  />
			</van-popup>
			<div style="line-height: 35px; font-weight: ">专业名称*</div>
			<div class="Select" @click="ShowPlacePopup">
			  <span style="float: left; color: rgb(186, 186, 186)"
			    >请选择时间</span
			  >
			  <span
			    style="float: right; margin-right: 10px; color: rgb(186, 186, 186)"
			    ><van-icon name="arrow-down"
			  /></span>
			</div>
			<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="PlaceShow"
			>
			  <!-- <h4>选择考试地点</h4> -->
			  <van-picker
			    show-toolbar
			    :columns="columns"
			    @confirm="onConfirm"
			    cancel-button-text="选择时间"
			  />
			</van-popup>
			<h3>上传毕业证书扫描件*</h3>
			<p>（PDF格式：每个文件小于1M）</p>
			<img src="../../assets/shouyeimage.png" />
			<h3>上传社保记录* <van-icon @click="socalinfo" name="info-o" /></h3>
			<p>（扫描件PDF格式：每个文件小于1M）</p>
			<img src="../../assets/shouyeimage.png" />
			<h3>身份证正反面*</h3>
			<p>（PDF格式：扫描放在一张A4纸上，每个文件小于1M）</p>
			<img src="../../assets/shouyeimage.png" />
			<img src="../../assets/shouyeimage.png" />
			<h3>证书邮寄地址*</h3>
			<input />
			<h3>上传本人证件照*</h3>
			<p>（2寸白底照:3.5cm*5.3cm。电子版jpg格式：像素306*378，每个图片小于200k，以身份证号命名）</p>
			<img src="../../assets/shouyeimage.png" />
			<h3>上传承诺书*</h3>
		</div>
		<van-button @click="onsubmit">提交报名</van-button>
	</div>
</template>

<script>
import Select from '@/components/Select'
export default {
  data() {
	return {
	  active: 0,
	  TimeShow: false,
	  PlaceShow: false,
	  actives: 0,
	  result:window.localStorage.getItem('result'),
	  radio: '',
	  columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
	};
  },
  components: {
	Select
  },
  methods:{
	  ShowPlacePopup() {
	    this.PlaceShow = true;
	  },
	  socalinfo(){
this.$router.push({path:'/social'})
	  },
	  onsubmit(){
		console.log("aaa")
		console.log(this.result)
		this.$router.push({path:'/order_form'});
	  },
  }
};
</script>

<style>
	img{
		height: 80px;
		width: 120px;
	}
	.rightcha {
	  float: left;
	}
	.rightcha img {
	  vertical-align: middle;
	  /* text-align: ; */
	}
	#top {
	  width: 100%;
	  height: 70px;
	  line-height: 70px;
	  vertical-align: middle;
	  background-color: rgba(245, 245, 245);
	}
	.centerwz{
		text-align: center;
	}
</style>
